import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import JustFlix from './components/JustFlix';
import TVChannels from './components/TVChannels';
import ActorDetails from './components/ActorDetails';
import ChannelPlayer from './components/ChannelPlayer';
import MediaDetails from './components/MediaDetails';
import Music from './components/Music';
import Podcasts from './components/Podcasts';
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";

const App: React.FC = () => {
    return (
        <>
            <Router>
                <Routes>
                    <Route path="/" element={<JustFlix />} />
                    <Route path="/tv" element={<TVChannels />} />
                    <Route path="/channel/:channelId" element={<ChannelPlayer />} />
                    <Route path="/media/:type/:id" element={<MediaDetails />} />
                    <Route path="/actor/:actorId" element={<ActorDetails />} />
                    <Route path="/music" element={<Music />} />
                    <Route path="/podcasts" element={<Podcasts />} />
                </Routes>
            </Router>
            <Analytics />
            <SpeedInsights />
        </>
    );
};

export default App;
